import { combineReducers } from "redux";
import masterReducer from "./master.reducer";
import detailMapReducer from "./detail-map.reducer";

export default combineReducers({
  dataMaster: masterReducer,
  paramsDetail: detailMapReducer
});
